export interface NavigationItem {
  id: string;
  title: string;
  icon?: string;
  url?: string;
  children?: NavigationItem[];
}

export const DEBTOR_NAVIGATION: NavigationItem[] = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    icon: 'dashboard',
    url: '/dashboard'
  },
  {
    id: 'profile',
    title: 'Profilo',
    icon: 'person',
    url: '/profile'
  },
  {
    id: 'documents',
    title: 'Documenti',
    icon: 'description',
    url: '/documents'
  },
  {
    id: 'advances',
    title: 'Anticipi',
    icon: 'request_quote',
    url: '/advances'
  }
];

// Legacy exports for backward compatibility
export const SELLER_NAVIGATION = DEBTOR_NAVIGATION;
export const BUYER_NAVIGATION: NavigationItem[] = [
  {
    id: 'account',
    title: 'Account',
    children: [
      {
        id: 'profile',
        title: 'Profilo',
        icon: 'person',
        url: '/profile'
      }
    ]
  },
  {
    id: 'buyer',
    title: 'Buyer',
    children: [
      {
        id: 'auctions',
        title: 'Aste',
        icon: 'gavel',
        url: '/auctions'
      },
      {
        id: 'portfolio',
        title: 'Portfolio',
        icon: 'folder',
        url: '/portfolio'
      }
    ]
  }
];

export const PARTNER_NAVIGATION: NavigationItem[] = [
  {
    id: 'account',
    title: 'Account',
    children: [
      {
        id: 'profile',
        title: 'Profilo',
        icon: 'person',
        url: '/profile'
      }
    ]
  },
  {
    id: 'partner',
    title: 'Partner',
    children: [
      {
        id: 'dashboard',
        title: 'Dashboard',
        icon: 'dashboard',
        url: '/dashboard'
      },
      {
        id: 'reports',
        title: 'Report',
        icon: 'assessment',
        url: '/reports'
      }
    ]
  }
];